module.exports = __webpack_public_path__ + "static/img/fahrzeugbewertung.1339f39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404_page/teaser/fahrzeugbewertung.jpg
// module id = QZ9s
// module chunks = 1